import { BrowserSearchEngine } from './common'

const defaultFieldSpecifiers = []

const defaultSyntaxGuideUrl = ''

class OpenAlexEngine extends BrowserSearchEngine {
  constructor (fieldSpecifiers) {
    super('Open Alex')
    this.fieldSpecifiers = fieldSpecifiers || defaultFieldSpecifiers
    this.syntaxGuideUrl = defaultSyntaxGuideUrl
  }

  formulateQuery (query) {
    return 'https://openalex.org/works?page=1&filter=default.search%3A' + query
  }

  lintQuery (queryGraphData) {
    const m = this.lintFieldSpecifiers(queryGraphData, this.fieldSpecifiers)
    return m ? [m] : []
  }

  getSuggestTermsMetaData () {
    return this.getSuggestTermsDbpediaSettings()
  }
}

export default OpenAlexEngine



// WEBPACK FOOTER //
// ./src/formulate_queries/OpenAlexEngine.js